// components/Footer.js
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      className="bg-secondary-800 dark:bg-secondary-900 text-secondary-300 dark:text-secondary-400 py-4 mt-auto"
      role="contentinfo"
    >
      <div className="max-w-content mx-auto px-4 sm:px-6 text-center text-sm">
        <p className="mb-2">
          © {new Date().getFullYear()} פותח שערים – הבית למורי הגמרא בחמ"ד
        </p>
        <div className="flex justify-center gap-4 flex-wrap text-secondary-400 dark:text-secondary-500">
          <Link to="/about"
                className="hover:text-white transition-colors no-underline hover:no-underline">
            אודות
          </Link>
          <Link to="/inspGreet"
                className="hover:text-white transition-colors no-underline hover:no-underline">
            ברכת המפמ"ר
          </Link>
          <span>|</span>
          <span>מפתח האתר - הרב אפרים שרם – shremim@gmail.com</span>
        </div>
      </div>
    </footer>
  );
}
